module.exports = __webpack_public_path__ + "static/media/start.b5837bc3.png";